import type { IconSvgObject } from './types';

const PenToolAddIcon: IconSvgObject = [
  ["path", { d: "M10.6016 16.3984L5 22M10 15C10.0419 15.4713 10.1813 15.9821 10.5996 16.4004C11.0179 16.8187 11.5287 16.9581 12 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 11L12.5 8.5L14.6885 5.84851C15.064 5.39356 15.7497 5.36084 16.1669 5.77797L21.222 10.8331C21.6392 11.2503 21.6064 11.936 21.1515 12.3115L18.5 14.5L16 21L5 22L6 11Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 8.5L18.5 14", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 5H8M5.00033 2L5.00033 8", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default PenToolAddIcon;
